import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getLanguage = createSelector([
  getConfigData,
], (config) => config.i18n.language);
